import React, { Component } from "react";
import PropTypes from 'prop-types';
import moment from 'moment';

import Avatar from "../../../ui/Avatar/Avatar";

import { formatPhone } from "../../../../methods";

class ClientMini extends Component {
  static propTypes = {
    client: PropTypes.object.isRequired,
  };

  render() {
    const { client } = this.props;

    return (
      <div className='row client mini'>
        <div className="ava">
          <Avatar avatar={client.avatar} />
        </div>
        <div className="cols-wrap">
          <div className="col name">{client.name} {client.surname}</div>
          <div className="col phone"><a href={`tel:${client.phone}`}>{formatPhone(client.phone)}</a></div>
          <div className="col email">
            <a href={`mailto:${client.email}`}>{client.email}</a>
          </div>
          <div className="col address">{client.address}</div>
          <div className="col date">{moment(client.created_at).format('DD.MM.YYYY')}</div>
          <div className="col consult-id">{client.consultant_id}</div>
        </div>
      </div>
    );
  }
}

export default ClientMini;
